import { ProductBarcode } from '../interfaces/product-barcode';

export function barcodesMapper(barcodes: ProductBarcode) {
  return Object.entries(barcodes).map(([key, value]) => {
    if (value) {
      const { baseImageUrl, ...info } = value;

      return {
        id: info.productId,
        product: { ...info, mainImageUrl: baseImageUrl },
        searchKey: key,
      };
    }

    return {
      id: key,
      product: null,
      searchKey: key,
    };
  });
}
